// Centralized test-id constants used across UTSAVA Genesis pages.
export const TID = {
    // Login
    loginEmail: "login-email-input",
    loginPassword: "login-password-input",
    loginSubmit: "login-submit-button",
    loginError: "login-error-message",

    // Shell
    sidebar: "primary-sidebar",
    topbar: "primary-topbar",
    userMenu: "user-menu-button",
    logout: "logout-button",
    navItem: (slug) => `nav-${slug}`,

    // Dashboard
    statTile: (slug) => `stat-${slug}`,
    severityChart: "severity-chart",
    engineChart: "engine-chart",
    recentActivity: "recent-activity-list",
    riskScoreGauge: "risk-score-gauge",

    // Workspaces
    workspaceList: "workspace-list",
    workspaceRow: (id) => `workspace-row-${id}`,
    newWorkspaceBtn: "new-workspace-button",
    workspaceNameInput: "workspace-name-input",
    workspaceDescInput: "workspace-description-input",
    workspaceCreateSubmit: "workspace-create-submit",
    workspaceUploadZone: "workspace-upload-zone",
    archiveReport: "archive-intake-report",
    workspaceUploadInput: "workspace-upload-input",
    workspaceAnalyzeBtn: "workspace-analyze-button",
    workspaceDeleteBtn: "workspace-delete-button",

    // Findings
    findingRow: (id) => `finding-row-${id}`,
    findingFilterSeverity: "finding-filter-severity",
    findingFilterEngine: "finding-filter-engine",

    // Recommendations
    recommendationCard: (id) => `recommendation-card-${id}`,
    recommendationApprove: (id) => `recommendation-approve-${id}`,
    recommendationReject: (id) => `recommendation-reject-${id}`,
    recommendationExplain: (id) => `recommendation-explain-${id}`,
    recommendationImpactEvidence: (id) => `recommendation-impact-evidence-${id}`,
    recommendationImpactBriefDownload: (id) => `recommendation-impact-brief-download-${id}`,
    recommendationImpactRecapture: (id) => `recommendation-impact-recapture-${id}`,
    recommendationImpactDirection: (id) => `recommendation-impact-direction-${id}`,
    recommendationImpactDepth: (id) => `recommendation-impact-depth-${id}`,

    // Graph
    graphCanvas: "knowledge-graph-canvas",
    graphFilter: "knowledge-graph-filter",
    graphNodePanel: "kg-node-panel",
    graphSearchInput: "kg-search-input",
    graphSearchResults: "kg-search-results",
    graphSearchResult: (i) => `kg-search-result-${i}`,
    graphImpactDepth: "kg-impact-depth",
    graphImpactDirection: "kg-impact-direction",
    graphImpactRun: "kg-impact-run",
    graphImpactPanel: "kg-impact-panel",
    graphImpactCount: "kg-impact-count",
    graphImpactClear: "kg-impact-clear",
    graphViewName: "kg-view-name",
    graphViewSave: "kg-save-view",
    graphViewOpen: (name) => `kg-view-open-${name}`,
    graphViewDelete: (name) => `kg-view-delete-${name}`,

    // Role Engineering (Sentinel Forge)
    roleGenerateInput: "role-generate-input",
    roleGenerateBtn: "role-generate-button",
    roleLoadTemplateBtn: "role-load-template-button",
    roleConsolidateBtn: "role-consolidate-button",
    roleRow: (id) => `role-row-${id}`,
    roleDeleteBtn: (id) => `role-delete-${id}`,
    roleAiDescribeBtn: (id) => `role-ai-describe-${id}`,
    roleExportBtn: (fmt) => `role-export-${fmt}`,
    roleSelectBox: (id) => `role-select-${id}`,
    roleSimulateBtn: "role-simulate-button",
    roleDefaultActvtToggle: "role-default-actvt-toggle",
    roleDefaultActvtCheckbox: (code) => `role-default-actvt-${code}`,

    // Role Engineering: Authorization Matrix Manager extensions
    roleTab: (tab) => `role-tab-${tab}`,
    roleToolsBtn: (id) => `role-tools-${id}`,
    roleToolsModal: "role-tools-modal",
    roleSapExportBtn: (id) => `role-sap-export-${id}`,
    roleOrgFieldsTab: "role-tools-org-fields-tab",
    roleSimulateTab: "role-tools-simulate-tab",
    roleReleaseTab: "role-tools-release-tab",
    roleDocsTab: "role-tools-docs-tab",
    roleFieldEditorTab: "role-tools-field-editor-tab",
    roleFieldEditorSaveBtn: "role-field-editor-save-button",
    roleFieldActvtCheckbox: (obj, code) => `role-field-actvt-${obj}-${code}`,
    roleFieldOrgInput: (obj, field) => `role-field-org-${obj}-${field}`,
    roleSimulateInput: "role-tools-simulate-input",
    roleSimulateRunBtn: "role-tools-simulate-run",
    roleDocBtn: (type) => `role-tools-doc-${type}`,
    roleDocDownloadBtn: "role-tools-doc-download",
    roleMigrationTab: "role-tools-migration-tab",
    roleMigrationConvertBtn: "role-migration-convert-button",
    roleMigrationResultPanel: "role-migration-result-panel",
    roleTemplateCard: (id) => `role-template-card-${id}`,
    roleTemplateGenerateBtn: (id) => `role-template-generate-${id}`,
    roleTemplateCategoryFilter: "role-template-category-filter",

    // Fiori Apps Library
    fioriSearchInput: "fiori-search-input",
    fioriSearchBtn: "fiori-search-button",
    fioriModuleFilter: "fiori-module-filter",
    fioriReleaseFilter: "fiori-release-filter",
    fioriAppRow: (id) => `fiori-app-row-${id}`,

    // Fiori Catalog-based Role Engineering
    fioriCatalogSearchInput: "fiori-catalog-search-input",
    fioriCatalogRow: (id) => `fiori-catalog-row-${id}`,
    fioriCatalogCheckbox: (id) => `fiori-catalog-checkbox-${id}`,
    fioriGroupNameInput: "fiori-group-name-input",
    fioriGroupCreateBtn: "fiori-group-create-button",
    fioriGroupRow: (id) => `fiori-group-row-${id}`,
    fioriGroupCheckbox: (id) => `fiori-group-checkbox-${id}`,
    fioriGroupDeleteBtn: (id) => `fiori-group-delete-${id}`,
    catalogRoleNameInput: "catalog-role-name-input",
    catalogRoleDescInput: "catalog-role-desc-input",
    catalogRoleGenerateBtn: "catalog-role-generate-button",
    catalogRoleResultPanel: "catalog-role-result-panel",

    // Instant Analysis
    instantAnalysisInput: "instant-analysis-input",
    instantAnalysisSubmit: "instant-analysis-submit",
    instantAnalysisResult: "instant-analysis-result",

    // Instant Analysis: Instant SoD Analyser
    sodAnalyserRoleCheckbox: (id) => `sod-analyser-role-${id}`,
    sodAnalyserExtraTcodesInput: "sod-analyser-extra-tcodes-input",
    sodAnalyserRunBtn: "sod-analyser-run-button",
    sodAnalyserResult: "sod-analyser-result",
    sodAnalyserExportBtn: (fmt) => `sod-analyser-export-${fmt}`,

    // Workspace: Artifact removal
    artifactDeleteBtn: (id) => `artifact-delete-${id}`,

    // Admin: SoD Ruleset Configuration
    rulesetConfigBtn: "ruleset-config-nav-button",
    rulesetTab: (tab) => `ruleset-tab-${tab}`,
    rulesetAddBtn: "ruleset-add-button",
    rulesetSearchInput: "ruleset-search-input",
    rulesetRiskRow: (id) => `ruleset-risk-row-${id}`,
    rulesetCriticalRow: (id) => `ruleset-critical-row-${id}`,
    rulesetFunctionRow: (id) => `ruleset-function-row-${id}`,
    rulesetEditBtn: (id) => `ruleset-edit-${id}`,
    rulesetDeleteBtn: (id) => `ruleset-delete-${id}`,
    rulesetFormSubmit: "ruleset-form-submit",
    rulesetResetBtn: "ruleset-reset-button",

    // Utsav AI Agent
    utsavNewChatBtn: "utsav-new-chat-button",
    utsavSessionItem: (id) => `utsav-session-${id}`,
    utsavDeleteSessionBtn: (id) => `utsav-delete-session-${id}`,
    utsavModelSelect: "utsav-model-select",
    utsavImageEngineSelect: "utsav-image-engine-select",
    utsavAutoSpeakToggle: "utsav-autospeak-toggle",
    utsavChatInput: "utsav-chat-input",
    utsavSendBtn: "utsav-send-button",
    utsavMicBtn: "utsav-mic-button",
    utsavSpeechLangSelect: "utsav-speech-lang-select",
    utsavStopBtn: "utsav-stop-button",
    utsavStreamingBubble: "utsav-streaming-bubble",
    utsavMemoryToggle: "utsav-memory-toggle",
    utsavMemoryPanel: "utsav-memory-panel",
    utsavAddFactInput: "utsav-add-fact-input",
    utsavAddFactBtn: "utsav-add-fact-button",
    utsavForgetFactBtn: (id) => `utsav-forget-fact-${id}`,
    utsavAttachBtn: "utsav-attach-button",
    utsavAttachInput: "utsav-attach-input",
    utsavAttachmentChip: (id) => `utsav-attachment-${id}`,
    utsavRemoveAttachment: (id) => `utsav-remove-attachment-${id}`,
    utsavExportBtn: (fmt) => `utsav-export-${fmt}`,
    utsavMsgCopy: (i) => `utsav-msg-copy-${i}`,
    utsavMsgCode: (i, j) => `utsav-msg-code-${i}-${j}`,
    utsavMsgTable: (i, j) => `utsav-msg-table-${i}-${j}`,
    utsavMsgImage: (i) => `utsav-msg-image-${i}`,

    // Dashboard: SoD Heatmap widget
    dashboardHeatmapRolesLink: "dashboard-heatmap-roles-link",
    verificationCoverageKpi: "verification-coverage-kpi",
    dashboardToxicRoleRow: (id) => `dashboard-toxic-role-${id}`,

    // Compare: Timeline Diff
    compareTab: (tab) => `compare-tab-${tab}`,
    timelineWorkspaceSelect: "timeline-workspace-select",
    timelineFromSelect: "timeline-from-select",
    timelineToSelect: "timeline-to-select",
    timelineRunBtn: "timeline-run-button",

    // Documentation: Guide Book
    docChapterTrigger: (title) => `doc-chapter-trigger-${title.replace(/[^a-zA-Z0-9]+/g, "-")}`,
    docChapterOpenBtn: (title) => `doc-chapter-open-${title.replace(/[^a-zA-Z0-9]+/g, "-")}`,

    // Governance: Compliance Map
    complianceMapCanvas: "compliance-map-canvas",
    complianceMapPin: (code) => `compliance-map-pin-${code}`,
    complianceMapDetail: "compliance-map-detail-panel",

    // Governance: Mitigation Library
    mitigationSearchInput: "mitigation-search-input",
    mitigationCategoryFilter: "mitigation-category-filter",
    mitigationTagFilter: "mitigation-tag-filter",
    mitigationAddBtn: "mitigation-add-button",
    mitigationCard: (id) => `mitigation-card-${id}`,
    mitigationEditBtn: (id) => `mitigation-edit-${id}`,
    mitigationDeleteBtn: (id) => `mitigation-delete-${id}`,
    mitigationFormSubmit: "mitigation-form-submit",

    // Documentation: Guide Book Search
    docSearchInput: "doc-search-input",

    // Admin: Dynamic RBAC / Custom Roles
    adminCustomRolesPanel: "admin-custom-roles-panel",
    adminCustomRoleCreateBtn: "admin-custom-role-create-button",
    adminCustomRoleNameInput: "admin-custom-role-name-input",
    adminCustomRoleModuleCheckbox: (key) => `admin-custom-role-module-${key}`,
    adminCustomRoleSubmit: "admin-custom-role-submit",
    adminCustomRoleRow: (id) => `admin-custom-role-row-${id}`,
    adminCustomRoleDeleteBtn: (id) => `admin-custom-role-delete-${id}`,
    adminCustomRoleEditBtn: (id) => `admin-custom-role-edit-${id}`,

    // Module Gate (dynamic RBAC restriction)
    moduleGateRestricted: (module) => `module-gate-restricted-${module}`,

    // Role Library: Catalog Coverage badge
    roleCatalogCoverageBadge: (id) => `role-catalog-coverage-${id}`,

    // Hologram AI Agent portrait (Login / Utsav / About / Dashboard)
    loginHologram: "login-hologram-portrait",
    utsavHeaderHologram: "utsav-header-hologram",
    utsavEmptyStateHologram: "utsav-empty-state-hologram",
    aboutCreatorHologram: "about-creator-hologram",
    dashboardHologram: "dashboard-hero-hologram",

    // Role Library: one-click Fiori Migration shortcut (next to T-Code-Only badge)
    roleMigrateShortcutBtn: (id) => `role-migrate-shortcut-${id}`,

    // Diagram Studio (Mermaid diagrams inside the Authorization Matrix Manager)
    // Behaviour Analytics (UEBA)
    uebaPage: "ueba-page",
    uebaHero: "ueba-hero",
    uebaIntake: "ueba-intake",
    uebaUpload: "ueba-upload",
    uebaUploadInput: "ueba-upload-input",
    uebaSeedDemo: "ueba-seed-demo",
    uebaPurge: "ueba-purge",
    uebaHourChart: "ueba-hour-chart",
    uebaEntities: "ueba-entities",
    uebaEntityRow: (u) => `ueba-entity-row-${u}`,
    uebaEntityOpen: (u) => `ueba-entity-open-${u}`,
    uebaEntityDetail: "ueba-entity-detail",
    uebaEntityClose: "ueba-entity-close",
    uebaAnomalies: "ueba-anomalies",
    uebaAnomaly: (id) => `ueba-anomaly-${id}`,
    uebaInvestigate: (id) => `ueba-investigate-${id}`,
    uebaDecision: (id, d) => `ueba-decision-${d}-${id}`,
    uebaEvidenceToggle: (id) => `ueba-evidence-${id}`,
    uebaCaseFile: (id) => `ueba-case-file-${id}`,
    uebaDecisionDialog: "ueba-decision-dialog",
    uebaDecided: "ueba-decided",

    // Intelligent SAP Security Diagnostic
    diagPage: "diagnostics-page",
    diagHero: "diagnostics-hero",
    diagRun: "diagnostics-run",
    diagPdf: "diagnostics-pdf",
    diagEmpty: "diagnostics-empty",
    diagVerdict: "diagnostics-verdict",
    diagScore: "diagnostics-score",
    diagMaturity: "diagnostics-maturity",
    diagTrend: "diagnostics-trend",
    diagTrendBar: (i) => `diagnostics-trend-bar-${i}`,
    diagRoadmap: "diagnostics-roadmap",
    diagRoadmapItem: (i) => `diagnostics-roadmap-item-${i}`,
    diagRoadmapDrill: (i) => `diagnostics-roadmap-drill-${i}`,
    diagDomains: "diagnostics-domains",
    diagDomain: (k) => `diagnostics-domain-${k}`,
    diagDomainDrill: (k) => `diagnostics-domain-drill-${k}`,

    roleDiagramsTab: "role-tools-diagrams-tab",
    roleBestPracticeTab: "role-tools-best-practice-tab",

    // Dynamic PFCG Role Content Update (best practice)
    bpTabPanel: "bp-tab-panel",
    bpScore: "bp-score",
    bpRescan: "bp-rescan",
    bpApplySelected: "bp-apply-selected",
    bpImpact: "bp-impact",
    bpClean: "bp-clean",
    bpHistoryToggle: "bp-history-toggle",
    bpHistory: "bp-history",
    bpProposal: (fp) => `bp-proposal-${fp}`,
    bpProposalSelect: (fp) => `bp-proposal-select-${fp}`,
    bpProposalValues: (fp) => `bp-proposal-values-${fp}`,
    bpProposalExpand: (fp) => `bp-proposal-expand-${fp}`,
    bpProposalDismiss: (fp) => `bp-proposal-dismiss-${fp}`,
    bpRestore: (fp) => `bp-restore-${fp}`,
    bpRollback: (fp) => `bp-rollback-${fp}`,
    bpDismissDialog: "bp-dismiss-dialog",
    bpSweepPanel: "bp-sweep-panel",
    bpSweepCard: "bp-sweep-card",
    bpRunSweep: "bp-run-sweep",
    bpSweepAverage: "bp-sweep-average",
    bpSweepRow: (id) => `bp-sweep-row-${id}`,
    bpSweepOpen: (id) => `bp-sweep-open-${id}`,
    bpPackCard: "bp-pack-card",
    bpPackInput: "bp-pack-input",
    bpPackUpload: "bp-pack-upload",
    bpPackActive: "bp-pack-active",
    bpPackCandidates: "bp-pack-candidates",
    bpRuleActivate: (id) => `bp-rule-activate-${id}`,
    bpRuleDelete: (id) => `bp-rule-delete-${id}`,
    diagramTemplateBtn: (id) => `diagram-template-${id}`,
    diagramCustomPromptInput: "diagram-custom-prompt-input",
    diagramCustomGenerateBtn: "diagram-custom-generate-btn",
    diagramRenderContainer: "diagram-render-container",
    diagramCopyCodeBtn: "diagram-copy-code-btn",
    diagramDownloadSvgBtn: "diagram-download-svg-btn",
    diagramDownloadPngBtn: "diagram-download-png-btn",
    diagramHistoryChip: (id) => `diagram-history-${id}`,
    diagramHistoryDeleteBtn: (id) => `diagram-history-delete-${id}`,
    diagramRefineInput: "diagram-refine-input",
    diagramRefineBtn: "diagram-refine-btn",
    crossRoleDiagramBtn: "cross-role-diagram-btn",

    // Bulk "Migrate All" — every T-Code-Only role onto Fiori Catalogs in one pass
    roleMigrateAllBtn: "role-migrate-all-button",
    migrateAllResultPanel: "role-migrate-all-result-panel",
    migrateAllRow: (id) => `migrate-all-row-${id}`,
    migrateAllDismissBtn: "role-migrate-all-dismiss",

    // Dashboard hero hologram hover reveal
    dashboardHologramTrigger: "dashboard-hologram-hover-trigger",
    dashboardHologramReveal: "dashboard-hologram-hover-reveal",

    // UTSAVA Genesis showreel (cinematic narrated film on Login + Dashboard)
    showreelLauncherBtn: "showreel-launcher-btn",
    showreelOverlay: "showreel-overlay",
    showreelStage: "showreel-stage",
    showreelPresenter: "showreel-presenter-image",
    showreelHeadline: "showreel-scene-headline",
    showreelCaption: "showreel-scene-caption",
    showreelSceneDot: (id) => `showreel-scene-dot-${id}`,
    showreelPlayToggle: "showreel-play-toggle",
    showreelSoundToggle: "showreel-sound-toggle",
    showreelSkipBtn: "showreel-skip-btn",
    showreelCloseBtn: "showreel-close-btn",

    // Theme gallery (6 visual identities)
    themeSwitcher: "theme-switcher",
    themeSwitcherBtn: "theme-switcher-button",
    themeSwitcherPanel: "theme-switcher-panel",
    themeOption: (id) => `theme-option-${id}`,

    // Genesis Gold dashboard hero + launchpad
    dashboardHeroBanner: "dashboard-hero-banner",
    heroCounter: (k) => `hero-counter-${k}`,
    heroCommandInput: "hero-command-input",
    heroCommandSubmit: "hero-command-submit",
    heroQuickPrompt: (k) => `hero-quick-prompt-${k}`,
    moduleLaunchpad: "module-launchpad",
    moduleTile: (id) => `module-tile-${id}`,

    // Code Review / RICEFW Security Clearance workbench
    crPage: "code-review-page",
    crPasteInput: "cr-paste-input",
    crAnalyzePasteBtn: "cr-analyze-paste-btn",
    crUploadInput: "cr-upload-input",
    crAnalyzeUploadBtn: "cr-analyze-upload-btn",
    crSessionRow: (id) => `cr-session-row-${id}`,
    crSessionDeleteBtn: (id) => `cr-session-delete-${id}`,
    crNewBtn: "cr-new-review-btn",
    crVerdictBadge: "cr-verdict-badge",
    crFindingRow: (key) => `cr-finding-${key}`,
    crFindingAtcConfirmed: (key) => `cr-finding-atc-confirmed-${key}`,
    crFindingExpand: (key) => `cr-finding-expand-${key}`,
    crFindingStatusSelect: (key) => `cr-finding-status-${key}`,
    crFindingComment: (key) => `cr-finding-comment-${key}`,
    crFindingSaveBtn: (key) => `cr-finding-save-${key}`,
    crFindingRefineBtn: (key) => `cr-finding-refine-${key}`,
    crMetaField: (name) => `cr-meta-${name}`,
    crMetaSaveBtn: "cr-meta-save-btn",
    crAtcImportInput: "cr-atc-import-input",
    crAtcSummary: "cr-atc-summary",
    crAtcImportBtn: "cr-atc-import-btn",
    crReportBtn: "cr-report-pdf-btn",
    crReanalyzeInput: "cr-reanalyze-input",
    crReanalyzeBtn: "cr-reanalyze-btn",
    crSeverityFilter: (sev) => `cr-severity-filter-${sev}`,
    crKpiTile: (k) => `cr-kpi-${k}`,
};
